<template>
  <div>
    <div v-if="(!!currentEngineModel.activeEngines) || (!!individualPendingRequests.pendingRequests)">
      <div class="border">
        <div class="headerRoles">
          <div class="headerboxlable1">Engine Model</div>
          <div class="headerboxlable1">Status</div>
        </div>
        <div v-if="(!!individualPendingRequests)">
          <div class="contentToDisplay">
            <div class="sideHeaderContainer">
              <div class="sideheader"> Pending </div>
            </div>
            <div v-for="[key, value] of individualPendingRequests">
              <div v-for="val of value">
                <div class="rolesStatus">
                  <div class="resourceNameValue">
                    {{ val.processVariables.engineModels }}
                  </div>
                  <div class="roleValue  valueColor">
                    <FrIcon class="mr-2" :outlined="false" name="autorenew" /> Pending
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="(!!currentEngineModel.activeEngines)">
          <div class="contentToDisplay">
            <div class="sideHeaderContainer">
              <div class="sideheader"> Active</div>
            </div>
            <div v-for="role in currentEngineModel.activeEngines">
                <div class="rolesStatus">
                  <div class="resourceNameValue">
                    {{ role.name }}
                  </div>
                  <div class="roleValue">
                    <FrIcon class="mr-2" :outlined="false" name="done" /> Active
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else> No Roles to Show</div>
  </div>
</template>

<script>
import { generateIdmApi } from '../../../api/BaseApi';
import FrIcon from '@forgerock/platform-shared/src/components/Icon';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'RelationshipViewEngineModel',
  components: {
    FrIcon,
  },
  props: {
    parentId: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      currentEngineModel: [],
      individualPendingRequests: []
    }
  },
  mounted() {
    this.getRoleRequestData();
  },
  methods: {
    getRoleRequestData() {
    
      generateIdmApi().get('/endpoint/getEngineModelRequests?userId=' + this.parentId).then((response) => {
        this.currentEngineModel = response.data
        console.log("values",this.currentEngineModel)
        console.log(this.currentEngineModel.pendingRequests)
        let pendingGroupedroles= new Map();
        let engineModelsArray = [];
        this.currentEngineModel.pendingRequests.forEach((info)=>{ 
        engineModelsArray = info.processVariables.engineModels.split(',')
        for (let eng in engineModelsArray){
          const key = engineModelsArray[eng]; 
          const values = pendingGroupedroles.get(key);
          if(!values){
            var infoClone = cloneDeep(info)
            infoClone.processVariables.engineModels = key
            pendingGroupedroles.set(key,[infoClone])
          } else {
            infoClone.processVariables.engineModels = key
            values.push(infoClone)
          }
        }
      })
      this.individualPendingRequests = pendingGroupedroles;
      })
    },

  }
}
</script>

<style>
.rolesStatus {
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 24px;
  border-top: 1px solid #E3E5E8;
  border-left: 1px solid #E3E5E8;
  border-right: 1px solid #E3E5E8;

}

.resourceNameValue {
  width: 50%;
  min-height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #000000;

}

.roleValue {
  width: 50%;
  min-height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #000000;
}

.border {
  border: 1px solid #F7F7F7;
}

.headerRoles {
  display: flex;
  height: 48px;
  align-items: center;
  gap: 10px;


}

.headerboxlable1 {
  width: 50%;
  height: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  padding-left: 24px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.headerboxlable23 {
  width: 50%;
  height: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.sideheader {
  width: 100%;
  height: 22px;
  font-size: 12px;
  line-height: 18px;
  color: #5B6376;
  font-weight: 600;
  display: flex;
  align-items: center;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.sideHeaderContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 24px;
  width: 100%;
  height: 32px;
  background: #F7F7F7;
  border: 1px solid #E3E5E8;
  text-transform: uppercase;
}

.contentToDisplay {
  display: flex;
  flex-direction: column;

}

.valueColor {
  color: #00A9E0
}
</style>